/**
 * CouncilHistory — list of recent saved council sessions, each linking to
 * its full transcript page.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { MessageSquare, ChevronRight } from 'lucide-react';

export default function CouncilHistory({ history, personas }) {
  if (!history?.length) return null;
  return (
    <div className="mt-6">
      <div className="ve-eyebrow">Recent councils</div>
      <div className="mt-3 space-y-2">
        {history.slice(0, 10).map((h) => (
          <Link
            key={h.council_id}
            to={`/dashboard/ai-council/${h.council_id}`}
            className="ve-card p-3 text-sm block hover:border-[#8B3FC5] hover:shadow-[0_0_20px_-12px_rgba(174,82,234,0.55)] transition"
            data-testid={`council-history-${h.council_id}`}
          >
            <div className="flex items-center justify-between gap-3 flex-wrap">
              <div className="flex items-center gap-2 min-w-0 flex-1">
                <MessageSquare size={14} className="text-slate-400 shrink-0"/>
                <span className="truncate">{h.question}</span>
              </div>
              <div className="flex items-center gap-1.5">
                {h.members.map((m) => (
                  <span key={m} className="text-[9px] uppercase tracking-[0.2em] font-bold px-2 py-0.5 rounded border border-slate-200">
                    {personas.find((p) => p.id === m)?.english_name || m}
                  </span>
                ))}
                <ChevronRight size={14} className="text-slate-400 group-hover:text-[#8B3FC5]"/>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
